import api from 'api'
import { ImpressaoComprovanteAgendamentoInput } from 'api/ImpressaoAgendamento'
import { CidadaoAtendimentoSelectFieldModel } from 'components/form'
import { useHandleImpressao } from 'hooks/impressao/useHandleImpressao'
import { formatNomeCidadao } from 'view/cidadao/util-cidadao'

export function useImpressaoComprovanteAgendamento() {
  const { handleImpressaoPath } = useHandleImpressao()

  const handleImpressaoComprovanteAgendamento = (
    cidadao: CidadaoAtendimentoSelectFieldModel,
    agendamentoId: string
  ) => {
    const nomeCidadao = formatNomeCidadao(cidadao)
    return handleImpressaoPath({
      apiPath: api.agendamento.gerarComprovanteAgendamento,
      values: { nomeCidadao, agendamentoId } as ImpressaoComprovanteAgendamentoInput,
      file: `${nomeCidadao.titleCase().split(' ').slice(0, 2).join('_')}_comprovante_agendamento.pdf`,
    })
  }

  const handleImpressaoComprovanteAgendamentoNome = (nomeCidadao: string, agendamentoId: string) => {
    return handleImpressaoPath({
      apiPath: api.agendamento.gerarComprovanteAgendamento,
      values: { nomeCidadao, agendamentoId } as ImpressaoComprovanteAgendamentoInput,
      file: `${nomeCidadao.titleCase().split(' ').slice(0, 2).join('_')}_comprovante_agendamento.pdf`,
    })
  }

  return { handleImpressaoComprovanteAgendamento, handleImpressaoComprovanteAgendamentoNome }
}
